import { useMutation } from "@tanstack/react-query";
import { type FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSession } from "../../app/session.js";
import { trpc } from "../../app/trpc.js";
import { Button, FormRow, Input, Notice, PageTitle } from "../../ui/index.js";
import { LocaleSwitch } from "../auth/index.js";

/** Профиль пользователя и язык интерфейса. */
export function ProfilePage() {
  const { t } = useTranslation();
  const session = useSession();
  const [name, setName] = useState(session.user?.name ?? "");
  const update = useMutation(trpc.auth.updateProfile.mutationOptions({ onSuccess: () => session.refresh() }));
  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    update.mutate({ name: name.trim() });
  };
  return (
    <div className="lg:max-w-3xl">
      <PageTitle>{t("settings.profileTitle")}</PageTitle>
      <div className="mb-6 flex items-center justify-between lg:justify-start lg:gap-6">
        <span className="text-sm text-slate-600">{t("settings.language")}</span>
        <LocaleSwitch />
      </div>
      <form onSubmit={onSubmit} className="space-y-4">
        <FormRow label={t("settings.profile")} htmlFor="name">
          <Input id="name" value={name} onChange={(e) => setName(e.target.value)} />
        </FormRow>
        {update.isSuccess && <Notice kind="success">{t("settings.saved")}</Notice>}
        <Button type="submit" disabled={update.isPending || !name.trim()}>
          {t("settings.save")}
        </Button>
      </form>
    </div>
  );
}
